import React from 'react';
import { Navigate } from 'react-router-dom';
import { isVCSubdomain } from '../utils/subdomainDetection';

interface VCRouteGuardProps {
  children: React.ReactNode;
  requireVCSubdomain?: boolean;
}

/**
 * Route guard for VC-specific routes
 * - If requireVCSubdomain is true, redirects to VC subdomain if not already there (production only)
 * - Allows access in development regardless of port
 */
const VCRouteGuard: React.FC<VCRouteGuardProps> = ({ 
  children, 
  requireVCSubdomain = false 
}) => {
  const isVC = isVCSubdomain();
  
  // In production, enforce VC subdomain requirement
  if (process.env.NODE_ENV === 'production' && requireVCSubdomain && !isVC) {
    // Redirect to VC subdomain
    const currentPath = window.location.pathname + window.location.search;
    window.location.href = `https://venture.sendupdates.ai${currentPath}`;
    return null;
  }
  
  return <>{children}</>;
};

export default VCRouteGuard;

